import { lazy } from 'react';
import { retry } from '../../../../config/utils';

const InstrumentsActive = lazy(() => retry(()=> import(/* webpackChunkName: "PartnerUploadLoan" */ "./index")));

export default InstrumentsActive;